import c from "./lib/createApi";

/**
 * 동시수정 관련
 */
export default {
  editCheck : c("POST", "/v1/simultaneous/editCheck", true), // 수정 중 체크
  aliveCheck : c("POST", "/v1/simultaneous/aliveCheck", true), // 네트워크 alive 체크
  saveable : c("POST", "/v1/simultaneous/saveable", true), // 수정 저장가능여부 확인
  statusUpdate : c("POST", "/v1/simultaneous/statusUpdate", true), // 수정 상태 업데이트
};
